import { render, staticRenderFns } from "./RefundLogisticDetail.vue?vue&type=template&id=9a13b5b8&scoped=true&"
import script from "./RefundLogisticDetail.vue?vue&type=script&lang=js&"
export * from "./RefundLogisticDetail.vue?vue&type=script&lang=js&"
import style0 from "./RefundLogisticDetail.vue?vue&type=style&index=0&id=9a13b5b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a13b5b8",
  null
  
)

export default component.exports